export enum EActiveFilter {
  SHOW_ALL = 0,
  INACTIVE,
  ACTIVE,
}

interface IStatusOption {
  label: string;
  value: number;
  message?: string;
}

export const statuses: IStatusOption[] = [
  { label: 'Active', value: EActiveFilter.ACTIVE, message: 'Showing Active Only' },
  { label: 'Inactive', value: EActiveFilter.INACTIVE, message: 'Showing Inactive Only' },
  { label: 'Show All', value: EActiveFilter.SHOW_ALL, message: 'Showing All' },
];
